export default "__VITE_ASSET__DlTg0aIW__";